import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiRootService } from '../apiroot.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EngineParamReportService {

  constructor(private http: HttpClient, private service: ApiRootService) { }

  getEngineParameters(vesselId: number, voyageNumber: string): Observable<any> {
    return this.http.get<any>(`${this.service.getBaseUrl()}/api/enginparameter/${vesselId}/${voyageNumber}`);
  }
  
  public updateRankSignatureByVesselAndVoyage(logbookAuthorizedBy: object): Observable<any> {
    return this.http.put(this.service.getBaseUrl() + '/api/updateMasterSingnatureAndRank', logbookAuthorizedBy);
  }
  

}
